<template>
  <b-container fluid class="mt-3">
    <div class="card">
      <div class="card-body">
        <div
          class="d-flex justify-content-center align-items-center h-100"
          v-if="isLoading"
        >
          <div class="loading"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <canvas id="metrique-chart"></canvas>
          </div>

          <div class="col-12 mt-4">
            <p class="text-center font-weight-bold">{{ description }}</p>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// import router from "../../router/router";
import AppConfig from "../../constants/AppConfig";
export default {
  name: "Detail",
  data() {
    return {
      metriqueData: {},

      isLoading: true,
      title: "",
      description: "",
      type: 30,
    };
  },
  methods: {
    async getMetriques() {
      this.isLoading = true;
      let type_input = this.$route.params.type_input;
      return fetch(
        AppConfig.apiUrl + `/v3/metrique/find?type_input=${type_input}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("ms-token"),
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          let labels = [];
          let data = [];
          for (let i = 0; i < res.data.length; i++) {
            labels.push(res.data[i].jour);
            data.push(res.data[i].value);
          }
          return { labels, data };
        });
    },
    configureChartOptions() {
      return {
        scales: {
          x: {
            display: true,
            title: {
              display: true,
              text: "Date",
              font: { size: 16, weight: "bold" },
            },
          },
          y: {
            ticks: {
              callback: (value) => {
                // Logique de formatage personnalisé
                return value;
              },
            },
            title: {
              display: true,
              text: "Valeur",
              font: { size: 16, weight: "bold" },
            },
          },
        },
        plugins: {
          datalabels: {
            // Configuration des étiquettes de données
          },
          tooltip: {
            callbacks: {
              label: (tooltipItem) => {
                // Logique de formatage des info-bulles
                return tooltipItem.formattedValue;
              },
            },
          },
        },
      };
    },

    getLabel() {
      let type_input = this.$route.params.type_input;

      switch (type_input) {
        case "alerte_all":
          return "Évolution quotidienne de l'utilisation des alertes";
        case "prestataire_all":
          return "Évolution quotidienne des inscriptions de prestataires";
        case "etablissement_all":
          return "Évolution quotidienne de la création d'établissements";
        case "patient_all":
          return "Évolution quotidienne des inscriptions de patients";
        case "alerte_audio":
          return "Évolution quotidienne de l'utilisation des alertes audio";
        case "alerte_texte":
          return "Évolution quotidienne de l'utilisation des alertes texte";
        case "alerte_image":
          return "Évolution quotidienne de l'utilisation des alertes image";
        case "alerte_disponibilite":
          return "Évolution quotidienne de l'utilisation du filtre de disponibilité";
        case "alerte_pays":
          return "Évolution quotidienne de l'utilisation du filtre par pays";
        case "alerte_ville":
          return "Évolution quotidienne de l'utilisation du filtre par ville";
        case "repartition_alertes_par_patient":
          return "Répartition des alertes par patient";

        default:
          return "Type de données inconnu";
      }
    },
    async recuperationParMois() {
      const { labels, data } = await this.getMetriques();
      this.metriqueData = {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              label: this.getLabel(),
              data,
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 2,
              fill: false,
            },
          ],
        },
        options: {
          ...this.configureChartOptions(),
          responsive: true,
          maintainAspectRatio: false,
        },
        plugins: [ChartDataLabels],
      };

      const ctx = document.getElementById("metrique-chart").getContext("2d");
      const chart = new Chart(ctx, this.metriqueData);

      // Définir une taille plus grande pour le graphe
      chart.canvas.parentNode.style.height = "500px";
      // chart.canvas.parentNode.style.width = "200%";

      this.isLoading = false;
    },
  },
  mounted() {
    this.recuperationParMois();
    window.addEventListener("resize", this.handleView);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleView);
  },
};
</script>

<style scoped>
canvas {
  max-width: 600px;
}
</style>
